<template>
<div class="chapter">
<div class="inner_page">
<section class="level1 hidden" data-number="2" epub:type="preface" id="preface">
<h1 class="hidden" data-number="2" epub:type="preface">Preface</h1>
<p class="no_header">The story of Emain Macha, the palace of Conor the Great King of Ulster and the home of the Heroes of the Red Branch; and of Cuchullain, the Hound of Cullan; and Leary, his charioteer.</p>
<p>Especially his charioteer, born Sigmund the German, brought to Rome as a hostage by Tiberius, washed up onto Ulster.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?2a99988c